import React, { memo, useEffect } from 'react'

import {
  HDatePicker,
  HInput,
  passParamsThrough,
  HSelect,
  DSelect
} from '../../../validation/HForm'
import {
  cityTypes,
  streetTypes,
} from '../../../helpers/data-constants'

const EmployerAdd = memo(({
  control,
  register,
  errors,
  reset,
  isLoading,
  country,
  handleOptions,
  tempEntity,
  variableValue
}) => {
  const props = {
    control,
    register,
    errors,
    reset,
    isLoading,
    country,
    handleOptions,
    tempEntity,
    variableValue
  }
  
  useEffect(() => {
    reset({
      "accountingPhone": tempEntity?.accountingPhone,
      "startDate": tempEntity?.startDate?.slice(0, 10),
      "endDate": tempEntity?.endDate?.slice(0, 10),
      "organization": tempEntity?.organization,
      "phone": tempEntity?.phone,
      "position": tempEntity?.position,
      "region": tempEntity?.employerAddress?.region,
      "cityType": tempEntity?.employerAddress?.cityType,
      "city": tempEntity?.employerAddress?.city,
      "streetType": tempEntity?.employerAddress?.streetType,
      "street": tempEntity?.employerAddress?.street,
      "house": tempEntity?.employerAddress?.house,
      "building": tempEntity?.employerAddress?.building,
      "apartment": tempEntity?.employerAddress?.apartment
    })
  }, [])

  return (
    passParamsThrough(
      <div>
        <fieldset>
          <div className="form-element">
            <label className="form-element-label" htmlFor="organization">Название организации</label>
            <div className="form-element-data">
              <HInput h="true" className="input" type="text" name="organization" id="organization" />
            </div>
          </div>
          <div className="form-element">
            <label className="form-element-label" htmlFor="position">Должность</label>
            <div className="form-element-data">
              <HInput h="true" className="input" type="text" name="position" id="position" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="phone">Телефон</label>
                <div className="form-element-data">
                  <HInput h="true" className="input" type="text" name="phone" id="phone" />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="accountingPhone">Телефон бухгалтерии</label>
                <div className="form-element-data">
                  <HInput h="true" className="input" type="text" name="accountingPhone" id="accountingPhone" />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="startDate">Принят</label>
                <div className="form-element-data date">
                  <HDatePicker h="true" className="input"
                    name="startDate"
                    id="startDate" />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="endDate">Уволен</label>
                <div className="form-element-data date">
                  <HDatePicker h="true" className="input"
                    name="endDate"
                    id="endDate" />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <div className="content-section-title">
            <h3>Адрес</h3>
          </div>
          <fieldset>
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="country">Страна</label>
                  <div className="form-element-data combobox">
                    <DSelect
                      h="true"
                      name="country"
                      isLoading={isLoading}
                      defaultValue={variableValue}
                      options={country}
                      handleOptions={handleOptions}
                      placeholder="Введите страну" />
                  </div>
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="region">Область</label>
                  <div className="form-element-data">
                    <HInput
                      h="true"
                      className="input"
                      type="text"
                      name="region"
                      id="region" />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="cityType">Тип населенного пункта</label>
                  <div className="form-element-data">
                    <HSelect
                      h="true"
                      className="input"
                      type="text"
                      name="cityType"
                      id="cityType"
                      options={["", ...cityTypes]} />
                  </div>
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="city">Населенный пункт</label>
                  <div className="form-element-data">
                    <HInput
                      h="true"
                      className="input"
                      type="text"
                      name="city"
                      id="city" />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="streetType">Тип адреса</label>
                  <div className="form-element-data">
                    <HSelect
                      h="true"
                      className="input"
                      type="text"
                      name="streetType"
                      id="streetType"
                      options={["", ...streetTypes]} />
                  </div>
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="contactsStreet">Улица</label>
                  <div className="form-element-data">
                    <HInput
                      h="true"
                      className="input"
                      type="text"
                      name="street"
                      id="street" />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="house">Дом</label>
                  <div className="form-element-data number">
                    <HInput
                      h="true"
                      className="input"
                      type="text"
                      name="house"
                      id="house" />
                  </div>
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="building">Корпус</label>
                  <div className="form-element-data number">
                    <HInput
                      h="true"
                      className="input"
                      type="text"
                      name="building"
                      id="building" />
                  </div>
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="apartment">Помещение</label>
                  <div className="form-element-data number">
                    <HInput
                      h="true"
                      className="input"
                      type="text"
                      name="apartment"
                      id="apartment" />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </fieldset>
      </div>, props)
  )
})

export default EmployerAdd
